import React, { useEffect, useRef, useState } from "react";
import "./HoppersContactus.scss"
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
import HoppersInputComponents from "../../components/HoppersInputComponents/HoppersInputComponents";
import HoppersTextArea from "../../components/HoppersInputComponents/HoppersTextArea";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";


const HoppersContactus = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "contactUs")
    const Components = page?.Components || []
    const companyDetails = useSelector((state) => state.companyData.company)
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [subject, setSubject] = useState("")

    const [phoneNumber, setPhoneNumber] = useState("")
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        message: "",
        phoneNumber: "",
        subject: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        let newErrors = {
            fullName: "",
            email: "",
            message: "",
            phoneNumber: "",
            subject: ""
        }
        const trimmedName = fullName.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        if (trimmedName === "") {
            newErrors.fullName = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.fullName = "Please enter a valid name";
            valid = false;
        }


        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }


        if (trimmedPhone === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        }

        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.ID || "",
            "Name": fullName,
            "Email": email,
            "PhoneNo": phoneNumber,
            "Message": message,
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFullName("")
                setMessage("")
                setPhoneNumber("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };

    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "HoppersContactus-Hero-header":
                return <div className="HoppersContactus-Hero-header">
                    {component?.Props?.text}
                </div>
            case "HoppersContactus-Hero-subheader":
                return <div className="HoppersContactus-Hero-subheader">
                    {component?.Props?.text1}<br />
                    {component?.Props?.text2}
                </div>
            case "HoppersContactus-Hero-cont":
                return <div className="HoppersContactus-Hero-cont">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="HoppersContactus-Hero"
                style={{
                    backgroundImage: `linear-gradient(#00000099,#00000099), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getListContent = (components) => {
        return (
            <div className="HoppersContactus-Details">
                {components?.map((data, key) => {
                    return (
                        <div className="HoppersContactus-Details-item" key={key}>
                            <img className="HoppersContactus-Details-item-img"
                                src={data?.icon} />
                            <div className="HoppersContactus-Details-item-header">{data?.header}</div>
                            <div className="HoppersContactus-Details-item-content">{data?.content}</div>

                        </div>
                    )
                })}
            </div>
        )
    }
    const getForm = () => {
        return (
            <div className="HoppersContactus-Form-container">
                <div className="HoppersContactus-Form-container-flex">
                    <HoppersInputComponents
                        placeholder={"Full Name"}
                        value={fullName}
                        onChange={(e) => {
                            setFullName(e.target.value)
                            handleChange("fullName")
                        }}
                        error={errors.fullName !== ""}
                        errorText={errors.fullName}
                        icon="user"
                    />
                    <HoppersInputComponents
                        placeholder={"Email"}
                        onChange={(e) => {
                            setEmail(e.target.value)
                            handleChange("email")

                        }}
                        value={email}
                        error={errors.email !== ""}
                        errorText={errors.email}
                        icon="email"
                    />

                    <HoppersInputComponents
                        placeholder={"Phone"}
                        onChange={(e) => {
                            setPhoneNumber(e.target.value)
                            handleChange("phoneNumber")

                        }}
                        value={phoneNumber}
                        error={errors.phoneNumber !== ""}
                        errorText={errors.phoneNumber}
                        icon="phone"
                        type="number"
                    />
                </div>

                <HoppersInputComponents
                    placeholder={"Subject"}
                    onChange={(e) => {
                        setSubject(e.target.value)
                        handleChange("subject")

                    }}
                    value={subject}
                    error={errors.subject !== ""}
                    errorText={errors.subject} />
                <HoppersTextArea
                    placeholder={"Message"}
                    onChange={(e) => {
                        setMessage(e.target.value)
                        handleChange("message")

                    }}
                    value={message}
                    error={errors.message !== ""}
                    errorText={errors.message} />
                {showSuccess && < div className="succes-alert">
                    ✔ Thanks for contacting us! We’ve received your message and will be in touch soon.
                </div>}
                <div className="HoppersContactus-Form-container-btn">
                    <Button
                        text={"Send Message"}
                        width={"max-content"}
                        onClick={handleContact}
                        isloading={loading} />
                </div>
            </div>
        )
    }
    const getFormComponent = (component) => {
        switch (component.ID) {
            case "HoppersContactus-Form-header":
                return <div className="HoppersContactus-Form-header">
                    {component?.Props?.text}
                </div>
            case "HoppersContactus-Form-subheader":
                return <div className="HoppersContactus-Form-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersContactus-Form-container":
                return getForm()
            default:
                return <div />
        }

    }
    const getFormContent = (components) => {
        return (
            <div className="HoppersContactus-Form">
                {sortByOrderAscending(components).map((component, key) => {
                    return (<div key={key}>
                        {getFormComponent(component)}
                    </div>)
                })}
            </div>
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="HoppersContactus-ImageCarousel" ref={containerRef}>
                <div className="HoppersContactus-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="HoppersContactus-Cont-image" />
                    ))}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersContactus-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "HoppersContactus-Details":
                return getListContent(component.Data)
            case "HoppersContactus-Form":
                return getFormContent(component.Components)
            case "HoppersContactus-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersContactus">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div >
    )
}
export default HoppersContactus